<template>
  <input
    v-if="filter.type === 'text'"
    class="appearance-none block w-full bg-white text-gray-700 border focus:border-blue-500 rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white"
    type="text"
    :value="where[filter.name]"
    @keyup.enter="changeFilter($event.target.value)"
    placeholder="Filtrar..."
  />
  <Treeselect
    v-else-if="filter.type === 'select'"
    :options="filter.async ? [] : options"
    :loadOptions="loadOptions"
    :async="filter.async"
    :value="where[filter.name]"
    noResultsText="Sin resultados..."
    searchPromptText="Escribe para buscar..."
    placeholder="Filtrar..."
    @input="changeFilter"
  />
  <DatePicker
    v-else-if="filter.type === 'date'"
    :value="new Date(where[filter.name])"
    locale="es"
    @dayclick="changeFilter"
  >
    <template v-slot="{ inputValue, inputEvents }">
      <input
        class="w-full appearance-none border rounded py-1 px-3 text-gray-700"
        :value="inputValue"
        v-on="inputEvents"
        placeholder="Filtrar..."
        readonly
      />
    </template>
  </DatePicker>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { DatePicker } from "v-calendar";

export default {
  components: {
    Treeselect,
    DatePicker,
  },
  props: {
    filter: {
      type: Object,
    },
  },
  computed: {
    ...mapState(["where"]),
    ...mapGetters(["currentTab"]),
    options() {
      if (Array.isArray(this.filter.options)) {
        return this.filter.options;
      }

      const options = new Set(
        this.filter.fromExtras
          ? this.currentTab.extras[this.filter.options].map(
              (item) => item[this.filter.optionName]
            )
          : this.currentTab.entries.map((item) => item[this.filter.optionName])
      );

      return Array.from(options).map((option) => {
        return { id: option, label: option };
      });
    },
  },
  methods: {
    ...mapActions(["filterEntries"]),
    changeFilter(value) {
      // https://github.com/riophae/vue-treeselect/issues/272
      // https://github.com/riophae/vue-treeselect/pull/334
      if (this.filter.type === "date") {
        this.filterEntries({
          name: this.filter.name,
          value: value.id,
        });
        return;
      }

      setTimeout(() => {
        this.filterEntries({
          name: this.filter.name,
          value,
        });
      }, 0);
    },
    loadOptions({ callback, searchQuery }) {
      if (searchQuery.length < 3) return;
      const options = this.options.filter(({ label }) =>
        label.toLowerCase().includes(searchQuery.toLowerCase())
      );
      callback(null, options);
    },
  },
};
</script>
